import { FEATURES, WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isMissingVehicle } from '@makemydeal/dr-sales-checkin-utils';
import type { WorkflowRule } from '../types';
import { isFeatureVisible } from '../../capabilities/selector';
import { getWorkflowInputsFromState } from '../workflowInputs';

// Showroom mode: deal is invalid specifically because vehicle is missing — unless a trade-in is
// already on the deal, which keeps it workable. Mirrors the BFF's MISSING_VEHICLE rule so a local
// re-evaluation cannot disagree with the applicationState the BFF stamped.
export const missingVehicleRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const isSalesViewRedirectionAllowed = isFeatureVisible(FEATURES.SALES_VIEW_REDIRECTION)(state ?? {});
    const signals = getWorkflowInputsFromState(state);

    return !isSalesViewRedirectionAllowed &&
        !signals.needsManagerApproval &&
        !signals.hasPublishedVersion &&
        !signals.approvedByManager &&
        !signals.isValid &&
        isMissingVehicle(signals)
        ? WorkflowStatus.MISSING_VEHICLE
        : null;
};
